<div class="db-hosting-redirects" id="db-hosting-redirects" >
  <div class="db-hosting-body-wrap" [ngClass]="{'db-page-with-banner': hasHostingBanner, 'db-redirects-page-empty': !redirects?.length}">


    <div class="db-redirects__filters"  *ngIf="redirects && redirects.length" id="add-redirects-header">
      <div class="db-redirects__add-redirect-filters">
        <label class="db-redirects__select-all-toggle">
          <span class="db-fc-checkbox"><input type="checkbox" [formControl]="selectAll" (change)="toggleAllItemsSelected($event.currentTarget.checked)"><span><i class="db-icon db-icon-check"></i></span></span>
          <span>{{'text_selectAll' | dbText}}</span>
        </label>
        <div class="db-redirects__divider"></div>
        <div class="db-redirects__assign-tags" (click)="confirmRemove(selectedRedirects, true)" [ngClass]="{'disabled': !hasCheckedRedirect}">
          <i class="db-icon db-icon-delete"></i>
          <span><span *ngIf="!checkedRedirectsCount || (checkedRedirectsCount && checkedRedirectsCount === 1)">DELETE ITEM</span><span *ngIf="checkedRedirectsCount && checkedRedirectsCount > 1">DELETE <b>{{checkedRedirectsCount === redirects.length ? 'ALL' : checkedRedirectsCount}} ITEMS</b></span></span>
        </div>
      </div>
      <div class="db-redirects__add-website">
        <a class="db-button sl-import-csv db-button_white" (click)="uploadCsv()"><span>{{'text_bulkImport' | dbText}}</span></a>
        <a class="db-button db-button_info" (click)="addRedirectDialog()" ><span>{{'text_addRedirect' | dbText}}</span></a>
      </div>
    </div>

    <div class="redirects-list-wrap">
      <div *ngIf="redirects && redirects.length">
        <div class="db-redirects__export-csv" >
          <a class="db-button sl-export-csv db-button_white" (click)="downloadCsv()"  [ngClass]="{'db-button_disabled': downloadLoading}" *ngIf="redirects && redirects.length">
            <span *ngIf="!downloadLoading">{{'text_exportCsv' | dbText}}</span>
            <db-loading-circular-spinner [color]="'blue'" *ngIf="downloadLoading"></db-loading-circular-spinner>
          </a>

          <div class="db-redirects-search-wrap">
            <db-fc-search-input [bigSize]="true"  [formControl]="searchTerm" [placeholderTitle]="'SEARCH Redirects'" [placeholder]="'text_searchEllipsis' | dbText"></db-fc-search-input>
          </div>
        </div>

        <div  class="db-redirects-block-body" >
          <div class="redirect-item" *ngFor="let redirect of filteredRedirects | pagination : {'currentPage': currentPage,'itemsPerPage': itemsPerPage}">
            <div class="redirect-item__checkbox">
              <label class="db-fc-checkbox"><input type="checkbox" [checked]="redirect.selected" (change)="onRedirectToggled($event, redirect)"><span><i class="db-icon db-icon-check"></i></span></label>
            </div>
            <div class="redirect-ite__type"><span class="redirect-item__name">Type</span><span>{{redirect?.statusCode}}</span></div>
            <div class="redirect-ite__name">
              <span class="redirect-item__name">Domains</span>
              <span class="redirect-item__name-value">
                  <span class="redirect-item__with-tooltip">
                    <span>{{redirect?.domainName}}</span>
                    <div class="redirect-item__tooltip">
                      <h6>Domains</h6>
                      <p class="auth-checkout__card-info-desc">{{redirect?.domainName}}</p>
                    </div>
                  </span>
                </span>
            </div>
            <div class="redirect-ite__value">
              <span class="redirect-item__name">Redirect From</span>
              <div >
                <div class="redirect-item__with-tooltip">
                  <span [innerHTML]="redirect?.redirectFrom"></span>
                  <div class="redirect-item__tooltip">
                    <h6>Redirect From</h6>
                    <p class="auth-checkout__card-info-desc" [innerHTML]="redirect?.redirectFrom"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="redirect-ite__ttl">
              <span class="redirect-item__name">Redirect To</span>
              <div >
                <div class="redirect-item__with-tooltip">
                  <span [innerHTML]="redirect?.redirectTo"></span>
                  <div class="redirect-item__tooltip">
                    <h6>Redirect To</h6>
                    <p class="auth-checkout__card-info-desc" [innerHTML]="redirect?.redirectTo"></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="redirect-ite__actions">
              <span (click)="addRedirectDialog(redirect)"><i class="db-icon db-icon-edit"></i></span>
              <div dbDropdownList [item]="redirect" [dbDropdownListPosition]="'dropdown'" [items]="removeRedirect" [toggleOnHover]="true">
                <a class="more-icon-wrap"><i class="db-icon db-icon-more2"></i></a>
              </div>
            </div>
          </div>
        </div>
        <db-pagination-controls *ngIf="filteredRedirects.length > itemsPerPage" (onChangePage)="onChangePage($event)" [currentPage]="currentPage" [pagesCount]="pagesCount" [itemsPerPage]="itemsPerPage" [itemsCount]="itemsCount"></db-pagination-controls>
      </div>
    </div>
    <div class="db-empty-redirects" *ngIf="redirects && !redirects.length">
      <div class="db-empty-redirects-text-title" [innerHTML]="'text_startOptimizingHeader' | dbText"></div>
      @if (primaryChanged) {
        <div class="db-empty-redirects-text-desc" [innerHTML]="'text_emptyRedirectsDesc' | dbText"></div>
      } @else {
        <div class="db-empty-redirects-text-desc">{{'text_redirectsOnlyAfterDomain' | dbText}}</div>
      }
      <div class="empty-actions-wrap">
        <a class="ds-btn ds-btn-m" [ngClass]="{'ds-btn-disabled': !primaryChanged}" (click)="uploadCsv()"><span>{{'text_bulkImport' | dbText | lowerCaseSpecificWords}}</span></a>
        <a class="ds-btn ds-btn-m  ds-btn-blue"  [ngClass]="{'ds-btn-disabled': !primaryChanged}" (click)="addRedirectDialog()"><span>{{'text_addRedirect' | dbText | lowerCaseSpecificWords}}</span></a>
      </div>
    </div>
    <db-empty-search [hideImage]="true" class="db-website-empty-search" *ngIf="redirects && redirects.length && filteredRedirects && !filteredRedirects.length"></db-empty-search>
  </div>
</div>
